import type { DTO } from '../core/index.ts'
import {
  vBoolean,
  vDate,
  vObject,
  vOptional,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'
import { workflows } from './common.ts'
import { loadStatuses } from './load.ts'
import { processStatuses } from './process-status.ts'

export const adminLoadSearchSchema = vObject({
  accountId: vOptional(vString()),
  carrierId: vOptional(vString()),
  search: vOptional(vString()),
  pickupDateStart: vOptional(vDate()),
  pickupDateEnd: vOptional(vDate()),
  bookedDateStart: vOptional(vDate()),
  bookedDateEnd: vOptional(vDate()),
  createdDateStart: vOptional(vDate()),
  createdDateEnd: vOptional(vDate()),
  sort: vOptional(vPicklist(['createdDate', 'pickupDate', 'bookedDate'])),
  sortDir: vOptional(vPicklist(['asc', 'desc'])),
  status: vOptional(vPicklist(loadStatuses)),
  workflow: vOptional(vPicklist(workflows)),
  freightCollect: vOptional(vBoolean()),
  pickupStatus: vOptional(vPicklist(processStatuses)),
})

export type AdminLoadSearchQuery = vOutput<typeof adminLoadSearchSchema>
export type AdminLoadSearchDTO = DTO<AdminLoadSearchQuery>
